import React, { useEffect, useRef, useState } from 'react';
import Player from '../Player/Player'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import $ from "jquery";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import axios from "axios";
import {
    FAVOURITES,
} from "../../url";
const ZoomThumbnail = (props) => {

    const [wishList, setwishList] = useState(props.isAddedinWishList);
    const [seemore, setseeMore] = useState(false)
    const [placeholderImage, setplaceholderImage] = useState();
    const [currentmylist, setcurrentmylist] = useState([]);
    let isAuth = localStorage.getItem('isAuth')

    useEffect(() => {
        const theme = localStorage.getItem('themeColor');
        const addedMylist = localStorage.getItem('addedMylist');
        // localStorage.setItem('addedMylist',[])
        if (theme === 'blckThem') {
            setplaceholderImage('dark')
        } else {
            setplaceholderImage('light')
        }

    }, [])
    //   }
    //   async deleteTomyList(item) {
    //     // // 
    //     let CurntBtn = this.TogglBtn.current
    //     let token = localStorage.getItem('token')
    //     // let entryid = item
    //     let formData = new FormData();
    //     formData.append("tag", "delete");
    //     formData.append("entryid", this.state.add_entry_id);
    //     CurntBtn.classList.remove("add-my-lst")
    //     await axios.post(FAVOURITES, formData, {
    //       headers: {
    //         'token': token
    //       }
    //     })
    //       .then(response => {
    //         // // 
    //         if (response.status === 200) {
    //           this.setState({
    //             isadded: false
    //           })
    //           let msg = response.data.Message;
    //           $("#snackbar .msg").html(msg);
    //           $("#snackbar")
    //             .addClass("show")
    //             .addClass("bg-danger")
    //             .removeClass("bg-sucess");
    //           setTimeout(function () {
    //             $("#snackbar").removeClass("show").removeClass("bg-danger");
    //           }, 3000);
    //         }
    //       }).catch((error) => {

    //       })


    //   }


    const seeMore = () => {
        setseeMore(!seemore)
    }
    // const isWishlistRemove = async () => {
    //     setwishList(!wishList);
    //     let formData = new FormData();
    //     formData.append("tag", "delete");
    //     formData.append("entryid", props.entryid);
    //     // CurntBtn.classList.add("add-my-lst")
    //     await axios.post(FAVOURITES, formData, {
    //         headers: {
    //             'token': localStorage.getItem("token")
    //         }
    //     })
    //         .then(response => {
    //             // // 
    //             if (response.status === 200 && response.data.favourite_status_flag === 0) {

    //                 let msg = response.data.Message;
    //                 // Get the existing data
    //              
    //                 let existing = localStorage.getItem('mylistAdded');
    //                 let arr = existing.split(',')

    //                 let arrtexisting = arr.pop(props.entryid);
    //                 localStorage.setItem('mylistAdded', arrtexisting);

    //                 $("#snackbar .msg").html(msg);
    //                 $("#snackbar")
    //                     .addClass("show")
    //                     .addClass("bg-success")
    //                     .removeClass("bg-danger");
    //                 setTimeout(function () {
    //                     $("#snackbar").removeClass("show").removeClass("bg-danger");
    //                 }, 3000);
    //             }
    //             else {
    //                 let msg = response.data.Message;
    //                 $("#snackbar .msg").html(msg);
    //                 $("#snackbar")
    //                     .addClass("show")
    //                     .addClass("bg-danger")
    //                     .removeClass("bg-success");
    //                 setTimeout(function () {
    //                     $("#snackbar").removeClass("show").removeClass("bg-success");
    //                 }, 3000);
    //             }
    //         }).catch((error) => {

    //         })
    // }
    const isWishlist = async (currentId, isremoved) => {
        setwishList(!wishList);
        let formData = new FormData();
        isremoved === 0 ? formData.append("tag", "delete") : formData.append("tag", "insert")
        // formData.append("tag", "insert");
        formData.append("entryid", currentId);
        // CurntBtn.classList.add("add-my-lst")
        await axios.post(FAVOURITES, formData, {
            headers: {
                'token': localStorage.getItem("token")
            }
        })
            .then(response => {
                // 
                // if (response.status === 200 && response.data.favourite_status_flag === 1) {
                // let currentId = props.entryid
                let previousData = localStorage.getItem('mylistAdded')
                if (previousData !== null && previousData !== undefined && previousData !== '') {
                    let finalData = JSON.parse(previousData)
                    // alert('finalData'+finalData)
                    let arrayChecker = finalData.includes(currentId);
                    if (arrayChecker) {
                        let indexValue = finalData.indexOf(currentId);
                        finalData.splice(indexValue, 1);
                        let localvalue = JSON.stringify(finalData)
                        localStorage.setItem('mylistAdded', localvalue);
                    }
                    else {

                        finalData.push(currentId)
                        let localvalue = JSON.stringify(finalData)
                        localStorage.setItem('mylistAdded', localvalue);
                    }
                } else {
                    let finalData = []
                    finalData.push(currentId)
                    let finalitem = JSON.stringify(finalData)
                    localStorage.setItem('mylistAdded', finalitem);

                }




                if (isremoved === 1) {
                    let msg = response.data.Message;
                    $("#snackbar .msg").html(msg);
                    $("#snackbar")
                        .addClass("show")
                        .addClass("bg-success")
                        .removeClass("bg-danger");
                    setTimeout(function () {
                        $("#snackbar").removeClass("show").removeClass("bg-danger");
                    }, 3000);
                } else {
                    let msg = response.data.Message;
                    $("#snackbar .msg").html(msg);
                    $("#snackbar")
                        .addClass("show")
                        .addClass("bg-danger")
                        .removeClass("bg-success");
                    setTimeout(function () {
                        $("#snackbar").removeClass("show").removeClass("bg-success");
                    }, 3000);
                }



            }).catch((error) => {

            })
    }
    const milisecondtohrs = (duration) => {

        var seconds = (duration / 1000).toFixed(0);
        var minutes = Math.floor(seconds / 60);
        var hours = "";
        if (minutes > 59) {
            hours = Math.floor(minutes / 60);
            hours = (hours >= 0) ? hours : "0" + hours;
            minutes = minutes - (hours * 60);
            minutes = (minutes >= 10) ? minutes : "0" + minutes;
        }

        seconds = Math.floor(seconds % 60);
        seconds = (seconds >= 10) ? seconds : "0" + seconds;
        if (hours != "") {
            return hours + " " + "hr" + " " + minutes + " " + "min" + " " + seconds + " " + "sec";
        }
        return minutes + " " + "min" + " " + seconds + " " + "sec";

    }

    let downloadUrlcookie = props.trailerdata !== undefined && props.trailerdata.length > 0 && props.trailerdata !== null ? "?Key-Pair-Id=" + props.trailerdata[0].cookies["CloudFront-Key-Pair-Id"] +
        "&Policy=" +
        props.trailerdata[0].cookies["CloudFront-Policy"] +
        "&Signature=" +
        props.trailerdata[0].cookies["CloudFront-Signature"] : ''
    let currentMylistValue = localStorage.getItem('mylistAdded') !== null && localStorage.getItem('mylistAdded') !== undefined && localStorage.getItem('mylistAdded') !== '' ? localStorage.getItem('mylistAdded') : []

    return (
        <>
            {
                props.trailerdata !== null && props.trailerdata !== undefined && props.trailerdata !== '' && props.trailerdata.length !== 0 ?
                    <div className="zoomContainer" style={{ left: props.eleLast > 2 && '-20px', minHeight: '0px' }}>
                        <div className="video_wrapper position-relative" >
                            <div className="transition w-100">
                                <Player
                                    id="videoPlayer"
                                    downloadUrlcookie={downloadUrlcookie}
                                    cookie={props.trailerdata !== undefined && props.trailerdata[0].cookies !== undefined && props.trailerdata[0].cookies !== null && props.trailerdata[0].cookies !== '' ? props.trailerdata[0].cookies : ''}
                                    videoUrl={props.trailerdata[0].downloadurl}
                                    isMuted={false}
                                    playing={props.playing}
                                    pageLink={props.pageLink} />
                            </div>
                        </div>
                        <div className='content pt-2 pl-3 pr-3 pb-3'>
                            <div className='d-flex align-items-center top mb-2'>
                                <Link to={props.pageLink} className='mr-auto d-flex align-align-center text-white play'><PlayCircleOutlineIcon /> <span className='ml-1'>Play</span></Link>

                                <span className='d-flex align-items-center ml-auto'>

                                    {
                                        isAuth !== undefined && isAuth !== null && isAuth !== '' && props.type === 'cat' ? <>{
                                            currentMylistValue.includes(props.entryid) === true && props.flag === 1 && wishList === true || currentMylistValue.includes(props.entryid) === true && wishList === true || currentMylistValue.includes(props.entryid) === true ? <Tooltip title={wishList === false ? 'remove to My List' : 'remove to My List'} placement="top" arrow>
                                                <span className='cursor' onClick={() => isWishlist(props.entryid, 0)}>
                                                    <PlaylistAddCheckIcon className={`text-white ${wishList === true ? 'text-y' : ''}`} />

                                                </span>
                                            </Tooltip> : <Tooltip title={wishList === true ? 'Added to My List' : 'Add to My List'} placement="top" arrow>
                                                <span className='cursor' onClick={() => isWishlist(props.entryid, 1)}>
                                                    <PlaylistAddIcon className={`text-white ${wishList === true ? 'text-y' : ''}`} />
                                                </span>
                                            </Tooltip>
                                        } </> : ''
                                    }


                                </span>
                            </div>
                            <h4 className='text-white mb-1'>{props.trailerdata[0].name}</h4>
                            {
                                props.description !== null && props.description !== undefined && props.description !== '' &&
                                <p className={`text-white des ${seemore !== false && 'show'}`}>
                                    {
                                        props.description
                                    }
                                </p>
                            }


                            {
                                props.description !== undefined && props.description !== null && props.description !== '' && <span className='text-y more d-block mt-2 font-14 cursor' onClick={seeMore}>See More {seemore !== false ? <RemoveIcon /> : <AddIcon />} </span>
                            }
                        </div>
                    </div> : ''
            }
        </>
    )
}
export default ZoomThumbnail;